import {AuthService} from './../../services/auth.service';
import {CompanyService} from './../../services/company.service';
import {TranslateService} from '@ngx-translate/core';
import {CategoryService} from './../../services/category.service';
import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NgEventBus} from 'ng-event-bus';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.css']
})
export class WizardComponent implements OnInit {

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  favoriteCategories = [];

  acceptedExtensions = ['xlsx', 'xls', 'csv'];
  isFileValid = true;

  model = {
    welcomeResponse: '',
    fallbackResponse: '',
    settings: {
      botName: '',
      botDescription: '',
      windowColor: '#20aee3',
      windowTextColor: '#ffffff',
      userMessageColor: '#20aee3',
      userMessageTextColor: '#fffffff',
      botMessageColor: '#f1f0f0',
      botMessageTextColor: '#000000',
      quickRepliesColor: '#20aee3',
      quickRepliesTextColor: '#ffffff'
    },
    favoriteCategories: [],
    xlsFile: undefined
  };

  constructor(
    private categoryService: CategoryService,
    private companyService: CompanyService,
    private eventBus: NgEventBus,
    private auth: AuthService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.categoryService.getFavoriteCategoriesList().subscribe(data => {
      this.favoriteCategories = data;
    });
  }

  addCategory(id) {
    this.model.favoriteCategories.push(id);
  }

  removeCategory(id) {
    this.model.favoriteCategories = this.model.favoriteCategories.filter(cat => cat !== id);
  }

  onFileChanged(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (this.acceptedExtensions.includes(file.name.split('.').pop())) {
        this.model.xlsFile = file;
        this.isFileValid = true;
      } else {
        this.isFileValid = false;
      }
    }
  }

  finishSetup() {
    this.eventBus.cast('notification: setupStart', {
      type: 'info',
      message: 'Setting up',
      id: `setup`,
      loading: true,
    });
    this.companyService.setupCompany(this.model).subscribe(result =>{
        this.eventBus.cast('notification: setupSuccess', {
          type: 'success',
          message: 'Setup complete',
          hide: `setup`,
          loading: false
        });
        this.auth.user.companyData.showSetup = false;
        this.auth.persistUser(this.auth.user);
      },
      error => {
        console.error(error);
        this.eventBus.cast('notification: setupError', {
          type: 'error',
          message: error.message,
          hide: `setup`,
          loading: false
        });
      }
    );
  }

}
